import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state:{
    adminleftnavnum:'0',
    arr:[],
    zifu:{},
    tyData:{},
    yxMsgList:{},
    courseMsg:{}
  },
  mutations: {
    setData(state,payload){
      state.arr=payload
    },
    setZifu(state,payload){
      state.zifu=payload
    },
    setstyData(state,payload){
      state.tyData=payload
    },
    // 获取当前游戏数据
		setYxMsgList(state, val) {
			if(val !== 'no'){
				state.yxMsgList = val;
			}else{
				state.yxMsgList = null
			}
		},
    // 保存课程信息
    setCourseMsg(state, val){
      state.courseMsg = val
    }
  },
  actions: {},
  modules: {},
});
